<template  >

  <el-row :gutter="20" >
    <slot name="default" ></slot>
    <div  v-show="value">
        <slot name="shrink" ></slot>
      </div>

  </el-row>

</template>

<script>
  export default {
    name: "index",
    data(){
      return {value:false}
    },
    props: ["show"],
    watch:{
      show(value){
        this.value=value;
     }
    }
  }
</script>

<style scoped>
  .draw-enter-active, .draw-leave-active {
    transition: all 1s ease;
  }
  .draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
    height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchForm/index.vue